import * as types from './constants';

// Get Network Merchant Status
export const getNetworkMerchantStatusRequest = data => (
  { type: types.GET_NETWORK_MERCHANT_STATUS_REQUEST, payload: data }
);

export const getNetworkMerchantStatusDone = data => (
  { type: types.GET_NETWORK_MERCHANT_STATUS_DONE, payload: data }
);

export const getNetworkMerchantStatusFailed = errors => (
  { type: types.GET_NETWORK_MERCHANT_STATUS_FAILED, payload: errors }
);

export const getNetworkMerchantStatusNotConnected = () => (
  { type: types.GET_NETWORK_MERCHANT_STATUS_NOT_CONNECTED }
);

// Set Network Merchant Rate
export const setNetworkMerchantRateRequest = data => (
  { type: types.SET_NETWORK_MERCHANT_RATE_REQUEST, payload: data }
);

export const setNetworkMerchantRateDone = data => (
  { type: types.SET_NETWORK_MERCHANT_RATE_DONE, payload: data }
);

export const setNetworkMerchantRateFailed = errors => (
  { type: types.SET_NETWORK_MERCHANT_RATE_FAILED, payload: errors }
);

// Set Network Merchant Locking Window
export const setNetworkMerchantLockingWindowRequest = data => (
  { type: types.SET_NETWORK_MERCHANT_LOCKING_WINDOW_REQUEST, payload: data }
);

export const setNetworkMerchantLockingWindowDone = data => (
  { type: types.SET_NETWORK_MERCHANT_LOCKING_WINDOW_DONE, payload: data }
);

export const setNetworkMerchantLockingWindowFailed = errors => (
  { type: types.SET_NETWORK_MERCHANT_LOCKING_WINDOW_FAILED, payload: errors }
);

// Request Network Activation
export const requestNetworkActivationRequest = data => (
  { type: types.REQUEST_NETWORK_ACTIVATION_REQUEST, payload: data }
);

export const requestNetworkActivationDone = data => (
  { type: types.REQUEST_NETWORK_ACTIVATION_DONE, payload: data }
);

export const requestNetworkActivationFailed = errors => (
  { type: types.REQUEST_NETWORK_ACTIVATION_FAILED, payload: errors }
);
